import { ApplicantMissingContactInfo } from "app/interface/applicationinvites";

export class ApplicationInvites {
    constructor (
        public DisplayMessage: string = "",
        public AllInvitesFirstNames: {} = null,
        public InvitesNotCompleteFirstNames: {} = null,
        public AllInvitesComplete: boolean = true,
        public ApplicantsWithMissingContactInformation: ApplicantMissingContactInfo[] = [],
    ) { }
}
